import React from "react";
import "../styles/LeakDetection.css"; // Make sure you create this CSS file

const leakAreas = [
    {
        name: "Akurdi",
        status: "Leak Detected",
        severity: "High",
        lastUpdated: "2025-04-04 10:45 AM",
    },
    {
        name: "Bijlinagar",
        status: "No Leak",
        severity: "None",
        lastUpdated: "2025-04-04 10:30 AM",
    },
    {
        name: "Nigdi",
        status: "Leak Suspected",
        severity: "Medium",
        lastUpdated: "2025-04-04 10:50 AM",
    },
];

const LeakDetection = () => {
    return (
        <div className="leak-detection-container">
            <h2>Leak Detection & Reports</h2>
            <div className="leak-list">
                {leakAreas.map((area, index) => (
                    <div className={`leak-card ${area.status.replace(/\s+/g, '-').toLowerCase()}`} key={index}>
                        <h3>{area.name}</h3>
                        <p><strong>Status:</strong> {area.status}</p>
                        <p><strong>Severity:</strong> {area.severity}</p>
                        <p><strong>Last Updated:</strong> {area.lastUpdated}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LeakDetection;
